export default __webpack_public_path__ + "static/media/gallery_01.9528ba79.jpg";